import React from 'react'
import { Box } from '@mui/joy'
import { NavButton } from './Buttons'
import { useData } from './DataProvider'
import useTranslation from '../shared/TranslationProvider'
import StepProgressHeading from './StepProgressHeading'
import { stepDescribedBy } from './stepProgress'

const Step1 = () => {
  const { candidate, setCurrentStep, step } = useData()
  const { t } = useTranslation()
  const welcomeMessage1Id = 'onboarding-step1-message-1'
  const welcomeMessage2Id = 'onboarding-step1-message-2'
  const welcomeMessage3Id = 'onboarding-step1-message-3'

  if (!candidate?.firstName) return null

  return (
    <Box
      className="mx-auto flex max-w-3xl flex-col flex-wrap content-center pt-10 text-center"
      data-testid="a11y-onboarding--step-1"
    >
      {/* CTS-9266 — YNS-020: one h1 per step */}
      <h1
        data-onboarding-step-heading
        tabIndex={-1}
        aria-describedby={stepDescribedBy(
          welcomeMessage1Id,
          welcomeMessage2Id,
          welcomeMessage3Id,
        )}
        className="mx-auto text-2xl font-bold focus:outline-none md:text-4xl"
      >
        {`${t('welcome')}, ${candidate.firstName}!`}
      </h1>
      <StepProgressHeading>
        {t('stepper_progress', { current: step })}
      </StepProgressHeading>
      <p
        id={welcomeMessage1Id}
        className="pt-4 text-center text-base md:pt-10 md:text-xl"
      >
        {t('welcome_message_1')}
      </p>
      <p
        id={welcomeMessage2Id}
        className="pt-4 text-center text-base md:text-xl"
      >
        {t('welcome_message_2')}
      </p>
      <p
        id={welcomeMessage3Id}
        className="pt-4 text-center text-base md:text-xl"
      >
        {t('welcome_message_3')}
      </p>
      <Box className="pt-10 text-center">
        <NavButton type={'continue'} onClick={() => setCurrentStep(2)}>
          {t('continue')}
        </NavButton>
      </Box>
    </Box>
  )
}

export default Step1
